import { useState } from "react";
import { Helmet } from "react-helmet-async";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./CoachingServices.css";
export default function Services() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const toggleContactModal = () => {
    setIsContactModalOpen(!isContactModalOpen);
  };

  return (
    <>
      <Helmet>
        <title>
          Virtual Financial Coaching Programs & Pricing | Certified Personal
          Finance Coach | Own Your Money
        </title>
        <meta
          name="description"
          content="Affordable certified financial coaching programs starting at $150. Debt management coaching, budget planning help for couples, emergency fund savings strategy, and financial accountability partner services. Virtual sessions nationwide."
        />
        <meta
          name="keywords"
          content="virtual financial coaching sessions, certified personal financial coach, debt management coaching program, budget planning help couples, emergency fund savings strategy, financial accountability partner, money mindset coaching, financial wellness consultant pricing, affordable financial coach NC"
        />

        <link
          rel="canonical"
          href="https://www.ownyourmoney.biz/coachingservices"
        />
        <meta
          property="og:title"
          content="Financial Coaching Services & Pricing | Own Your Money"
        />
        <meta
          property="og:description"
          content="Affordable financial coaching packages: Moneymoon, Get-On-Your-Feet, and Know-Your-Money. Virtual sessions available nationwide."
        />

        <meta
          property="og:url"
          content="https://www.ownyourmoney.biz/coachingservices"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.ownyourmoney.biz/og-image.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <meta name="geo.region" content="US-NC" />
        <meta name="geo.country" content="United States" />
        <meta name="geo.placename" content="Holly Springs, NC" />
        <meta name="geo.position" content="35.65;-78.83" />
        <meta name="ICBM" content="35.65, -78.83" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="en-US" />
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.ownyourmoney.biz/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Services",
          "item": "https://www.ownyourmoney.biz/coachingservices"
        }
      ]
    }
    `}
        </script>

        {/* Combined FinancialService + Organization Schema */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      "name": "Own Your Money LLC",
      "url": "https://www.ownyourmoney.biz",
      "logo": "https://www.ownyourmoney.biz/static/media/logo.a289caf420b85a4e241ff32552050a01.svg",
      "image": "https://www.ownyourmoney.biz/og-image.png?v=2",
      "description": "Personalized financial coaching and consulting services to help clients across North Carolina and the U.S. gain financial clarity, confidence, and control.",
      "telephone": "+1-919-285-1689",
      "email": "OwnYourMoneyNC@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Holly Springs",
        "addressRegion": "NC",
        "addressCountry": "US"
      },
      "areaServed": [
        { "@type": "State", "name": "North Carolina" },
        { "@type": "Country", "name": "United States" }
      ],
      "founder": {
        "@type": "Person",
        "name": "Wendy Toh",
        "jobTitle": "Certified Personal Financial Wellness Consultant"
      },
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+1-919-285-1689",
          "contactType": "customer service",
          "areaServed": ["US", "NC"],
          "availableLanguage": ["English"],
          "email": "OwnYourMoneyNC@gmail.com"
        }
      ],
      "sameAs": [
        "https://www.linkedin.com/in/wendytoh",
        "https://www.facebook.com/ownyourmoney"
      ],
      "serviceType": [
        "Financial Coaching",
        "Budget Planning",
        "Financial Wellness",
        "Debt Management",
        "Couples Financial Coaching"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Coaching Packages",
        "itemListElement": [
          {
            "@type": "Offer",
            "name": "Dream to Doorstep Package",
            "price": "750",
            "priceCurrency": "USD",
            "description": "Guidance for aspiring homebuyers to prepare financially for homeownership."
          },
          {
            "@type": "Offer",
            "name": "Get On Your Feet Package",
            "price": "900",
            "priceCurrency": "USD",
            "description": "Financial coaching for those navigating major life transitions."
          },
          {
            "@type": "Offer",
            "name": "Know Your Money Package",
            "price": "1100",
            "priceCurrency": "USD",
            "description": "Coaching for individuals seeking better money management and budgeting habits."
          },
          {
            "@type": "Offer",
            "name": "MoneyMoon Package",
            "price": "1250",
            "priceCurrency": "USD",
            "description": "Couples coaching to build shared financial understanding and confidence."
          }
        ]
      },
      "priceRange": "$$"
    }
    `}
        </script>
      </Helmet>

      <Header />
      <main className="services-main-body">
        <section className="pricing-section">
          <div className="container">
            <div className="section-header">
              <h2>Own Your Money Financial Wellness Offerings</h2>
              <p>Choose the program that fits your needs.</p>
            </div>
            <article
              id="financial-fitness"
              className="package financial-fitness"
            >
              <header className="package-header">
                <div>
                  <h3 className="package-title">
                    Financial Fitness Assessment
                  </h3>
                  <div className="package-price">$250</div>
                </div>
              </header>

              <p className="package-description">
                I will work with you to gather your financial data. We will
                discuss areas of concern and your priorities. If you choose to
                purchase a coaching package after the session, your fee will be
                credited towards the cost of the package.
              </p>
              <div className="package-content">
                <div className="content-section">
                  <h4>Who This is For</h4>
                  <p>
                    This is for someone who wants a comprehensive view of their
                    current financial situation before committing to a full
                    coaching package.
                  </p>
                  <br />
                  <h4>What You'll Walk Away With</h4>
                  <ul className="feature-list">
                    <li>
                      A comprehensive understanding of your overall financial
                      situation
                    </li>
                    <li>
                      A written report detailing your income, expenses, assets,
                      and liabilities
                    </li>
                  </ul>
                </div>
                <div className="content-section">
                  <h4>What's Included</h4>
                  <div className="included-item">
                    <h5>
                      Detailed assessment of income, expenses, assets, and
                      liabilities
                    </h5>
                    <ul>
                      <li>
                        One 30-minute onboarding session with guidance on data
                        collection
                      </li>
                      <li>A comprehensive written report and assessment</li>
                      <li>
                        One 60-minute session to review your report/data to
                        identify gaps, risks, and opportunities
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </article>
            <article id="dream-to-doorstep" className="package dream-doorstep">
              <header className="package-header">
                <div>
                  <h3 className="package-title">Dreams to Doorstep Package</h3>
                  <div className="package-price">$750</div>
                </div>
              </header>

              <p className="package-description">
                Buying your first home is one of the biggest financial steps
                you'll ever take—both exciting and overwhelming. This program is
                designed to help you move from "someday" to "ready," by creating
                a clear, confident path toward homeownership within the next 3
                months to 12 months. Whether you're just starting to dream about
                owning a home or already exploring listings, this program helps
                you build the financial foundation, strategy, and mindset to
                make it happen.
              </p>
              <div className="package-content">
                <div className="content-section">
                  <h4>Who This Is For</h4>
                  <p>This package is ideal for aspiring homebuyers who feel:</p>
                  <ul className="feature-list">
                    <li>
                      Motivated to buy a home but unsure what they can afford
                    </li>
                    <li>Confused by what lenders or realtors expect</li>
                    <li>
                      Struggling to save for a down payment or reduce debt
                    </li>
                    <li>
                      Eager to strengthen their financial position before
                      applying
                    </li>
                    <li>Overwhelmed by conflicting advice or next steps</li>
                    <li>
                      Ready for clarity, accountability, and expert guidance
                    </li>
                  </ul>
                  <br />
                  <h4>What You'll Walk Away With</h4>
                  <ul className="feature-list">
                    <li>A clear understanding of what you can afford</li>
                    <li>
                      A customized, realistic plan for homeownership readiness
                    </li>
                    <li>
                      Practical approaches to manage credit, savings, and debt
                      strategically
                    </li>
                    <li>
                      Confidence and peace of mind as you move toward your first
                      home
                    </li>
                  </ul>
                </div>
                <div className="content-section">
                  <h4>What's Included</h4>
                  <div className="included-item">
                    <h5>1. Homebuyer Readiness Session</h5>
                    <ul>
                      <li>
                        Clarify your homeownership goals, timeline, and
                        financial motivators
                      </li>
                      <li>
                        Review your current financial landscape—income, savings,
                        debt, and credit
                      </li>
                      <li>
                        Identify what's holding you back and where to focus
                        first
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>2. Financial Snapshot + Mortgage Prep Audit</h5>
                    <ul>
                      <li>Assess your borrowing readiness</li>
                      <li>
                        Identify key benchmarks lenders look for (credit, DTI,
                        reserves)
                      </li>
                      <li>
                        Create a savings and debt-reduction strategy aligned
                        with your target home price
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>3. Personalized Homebuying Roadmap</h5>
                    <ul>
                      <li>
                        Step-by-step plan from today's reality to homeownership
                        readiness
                      </li>
                      <li>
                        Customized savings targets, debt payoff priorities, and
                        timeline milestones
                      </li>
                      <li>
                        Resources for understanding mortgage options, down
                        payment programs, and closing costs
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>4. Access to Educational Materials</h5>
                    <ul>
                      <li>
                        Curated resources to support your learning between
                        sessions
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </article>
            <article id="getOnYourFeet" className="package get-feet">
              <header className="package-header">
                <div>
                  <h3 className="package-title">Get On Your Feet Package</h3>
                  <div className="package-price">$900</div>
                </div>
              </header>
              <p className="package-description">
                Life can shift in an instant, whether through loss, transition,
                or unexpected opportunity. This package is designed for
                individuals navigating a significant change in their financial
                landscape, such as loss of a partner, job change, job loss,
                career pivot, retirement, inheritance, financial windfall, major
                life transitions like relocation or caregiving. Whether the
                change was planned or sudden, this program helps you pause,
                reflect, and move forward with intention.
              </p>
              <div className="package-content">
                <div className="content-section">
                  <h4>Who This Is For</h4>
                  <p>This package is ideal for someone who feels:</p>
                  <ul className="feature-list">
                    <li>
                      Overwhelmed by financial decisions after a major life
                      event
                    </li>
                    <li>Unsure how to move forward or where to begin</li>
                    <li>
                      Ready to take control but craving guidance and emotional
                      support
                    </li>
                    <li>
                      Seeking a safe, structured space to rebuild with
                      confidence
                    </li>
                  </ul>
                  <br />
                  <h4>What You'll Walk Away With</h4>
                  <ul className="feature-list">
                    <li>
                      A clear understanding of your financial starting point
                    </li>
                    <li>A customized plan that reflects your new reality</li>
                    <li>Increased financial knowledge and skills</li>
                    <li>Renewed confidence and peace of mind</li>
                  </ul>
                </div>
                <div className="content-section">
                  <h4>What's Included</h4>
                  <div className="included-item">
                    <h5>1. Discovery Session</h5>
                    <ul>
                      <li>
                        A compassionate deep dive into your current financial
                        reality
                      </li>
                      <li>
                        Explore emotional responses to change and financial
                        stress
                      </li>
                      <li>
                        Clarify your values, priorities, and immediate concerns
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>2. Financial Clarity Audit</h5>
                    <ul>
                      <li>
                        Review of income, expenses, assets, and liabilities
                      </li>
                      <li>Identify gaps, risks, and opportunities</li>
                      <li>Organize and simplify your financial picture</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>3. Personalized Action Plan</h5>
                    <ul>
                      <li>
                        Create a step-by-step roadmap tailored to your new
                        situation
                      </li>
                      <li>
                        Prioritize short-term stability and long-term goals
                      </li>
                      <li>Include decision-making tools and mindset support</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>4. Access to Educational Materials</h5>
                    <ul>
                      <li>
                        Curated resources to support your learning between
                        sessions.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </article>
            <article id="know-your-money" className="package know-money">
              <header className="package-header">
                <div>
                  <h3 className="package-title">Know Your Money Package</h3>
                  <div className="package-price ">$1,100</div>
                </div>
              </header>

              <p className="package-description">
                This program is designed for individuals who are ready to shift
                to confident money management. Whether you're tired of feeling
                reactive with your spending, unsure how to save consistently, or
                simply want a system that reflects your values, this package
                offers the structure, support, and insight to help you take
                charge.
              </p>
              <div className="package-content">
                <div className="content-section">
                  <h4>Who This Is For</h4>
                  <p>You might be a great fit if you're:</p>
                  <ul className="feature-list">
                    <li>
                      Feeling out of sync with your spending and saving habits
                    </li>
                    <li>Unsure where your money is going each month</li>
                    <li>
                      Ready to break patterns of avoidance, guilt, or
                      impulsivity
                    </li>
                    <li>
                      Seeking a personalized budget system that feels doable and
                      aligned
                    </li>
                    <li>
                      Craving accountability and emotional support as you build
                      new habits
                    </li>
                  </ul>
                  <br />
                  <h4>What You'll Walk Away With</h4>
                  <ul className="feature-list">
                    <li>
                      A comprehensive understanding of your overall financial
                      situation
                    </li>
                    <li>
                      A personalized budget and tools to manage spending,
                      saving, and tracking
                    </li>
                    <li>
                      A written plan to reach your short- and long-term
                      financial goals
                    </li>
                    <li>
                      The skills and mindset to make intentional, values-aligned
                      money decisions
                    </li>
                  </ul>
                </div>
                <div className="content-section">
                  <h4>What's Included</h4>
                  <div className="included-item">
                    <h5>1. Discovery Session</h5>
                    <ul>
                      <li>Understand your financial sentiment and habits</li>
                      <li>
                        Explore emotional responses to change and financial
                        stress
                      </li>
                      <li>
                        Clarify your values, priorities, and immediate concerns
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>2. Financial Deep Dive</h5>
                    <ul>
                      <li>
                        Detailed assessment of income, expenses, assets, and
                        liabilities
                      </li>
                      <li>Identify gaps, risks, and opportunities</li>
                      <li>
                        Assess learning style and money management tool
                        preferences
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>3. Personalized Action Plan</h5>
                    <ul>
                      <li>
                        Establish and prioritize short-term and long-term goals
                      </li>
                      <li>Create a roadmap with key milestones</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>4. Money Management Plan</h5>
                    <ul>
                      <li>
                        A written budget tailored to your income and priorities
                      </li>
                      <li>Tools for tracking and adjusting spending</li>
                      <li>Savings strategies that feel achievable</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>5. Access to Educational Materials</h5>
                    <ul>
                      <li>
                        Curated resources to support your learning between
                        sessions
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </article>

            <article id="moneymoon" className="package moneymoon">
              <header className="package-header">
                <div>
                  <h3 className="package-title">
                    Moneymoon: Where Love Meets Money
                  </h3>
                  <div className="package-price">$1,250</div>
                </div>
              </header>
              <p className="package-description">
                First came the Honeymoon. Then the Babymoon. Now it's time for
                the <em>Moneymoon</em>, a transformational experience for
                couples ready to build financial intimacy. Whether you're
                newlyweds merging bank accounts or long-time partners rethinking
                your money habits, this coaching program is designed to help you
                navigate the emotional and practical terrain of shared finances
                with clarity, compassion, and confidence.
              </p>
              <div className="package-content">
                <div className="content-section">
                  <h4>Who This Is For</h4>
                  <p>
                    This experience is designed for couples who are ready to
                    deepen their financial connection and build a shared
                    foundation rooted in trust, clarity, and emotional safety.
                    You might be:
                  </p>
                  <ul className="feature-list">
                    <li>
                      Newlyweds or engaged partners merging finances for the
                      first time and wanting to start strong
                    </li>
                    <li>
                      Long-time couples who feel stuck in old money patterns and
                      want a fresh, intentional reset
                    </li>
                    <li>
                      Partners with different financial styles—spender vs.
                      saver, structured vs. spontaneous—seeking harmony instead
                      of friction
                    </li>
                    <li>
                      Couples planning major life transitions like buying a
                      home, starting a family, or changing careers
                    </li>
                  </ul>
                  <br />
                  <h4>What You'll Walk Away With</h4>
                  <ul className="feature-list">
                    <li>A shared understanding of your goals & priorities</li>
                    <li>
                      A strategy to navigate money conversations with confidence
                      and empathy
                    </li>
                    <li>
                      A practical framework for managing your finances together
                    </li>
                    <li>
                      A sense of trust, collaboration, and mutual accountability
                    </li>
                  </ul>
                </div>
                <div className="content-section">
                  <h4>What's Included</h4>
                  <div className="included-item">
                    <h5>1. Individual Discovery Sessions</h5>
                    <ul>
                      <li>Gain context and emotional background</li>
                      <li>
                        Clarify your values, priorities, and immediate concerns
                      </li>
                      <li>Understand your individual financial identity</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>2. Couples Coaching Sessions</h5>
                    <ul>
                      <li>Explore financial sentiment and money stories</li>
                      <li>
                        Understand each partner's financial personality and
                        behaviors
                      </li>
                      <li>
                        Develop strategies to address emotionally-charged
                        financial topics
                      </li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>3. Financial Clarity Audit</h5>
                    <ul>
                      <li>
                        Review of income, expenses, assets, and liabilities
                      </li>
                      <li>Identify gaps, risks, and opportunities</li>
                      <li>Organize and simplify your financial picture</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>4. Personalized Action Plan</h5>
                    <ul>
                      <li>
                        Clarify and prioritize joint financial vision and goals
                      </li>
                      <li>Align on a decision making framework</li>
                      <li>Create a written financial plan</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>5. Money Managment Plan</h5>
                    <ul>
                      <li>
                        A written budget tailored to your income and priorities
                      </li>

                      <li>Tools for tracking and adjusting spending</li>
                      <li>Savings strategies that feel achievable</li>
                    </ul>
                  </div>
                  <div className="included-item">
                    <h5>6. Access to Educational Materials</h5>
                    <ul>
                      <li>
                        Curated resources to support your learning between
                        sessions.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </article>
            <div className="additional-options">
              <h3 className="additional-options-header">Additional Options</h3>
              <div className="options-grid">
                {/* Card 1: Ongoing Support - Now direct child */}
                <div className="option-card support">
                  <h4>Ongoing Support & Accountability</h4>
                  <span>For Existing Clients</span>
                  <div className="support-options">
                    <div className="support-option">
                      <ul className="support-option">
                        <li>A 45-minute coaching session</li>
                        <li>Up to 20 emails</li>
                        <li>Weekly check-in texts</li>
                        <li>Document reviews ahead of coaching</li>
                        <li>Updates to written plans</li>
                      </ul>
                    </div>
                    <div className="price-container">
                      <p className="option-price">$120/month</p>
                    </div>
                  </div>
                </div>

                <div className="option-card ">
                  <h4>Custom Packages</h4>
                  <div className="support-option">
                    <ul>
                      <li>Custom-tailored for your unique needs and budget</li>
                      <li>Contact Wendy to discuss your options</li>
                    </ul>
                  </div>
                  <p className="option-price">Available</p>
                </div>

                {/* Card 4: Gift Certificates - Now direct child */}
                <div className="option-card gift-certificate">
                  <h4>Gift Certificates</h4>
                  <div className="support-option">
                    <p className="gift-certificate-description">
                      Gift certificates are available for each package or a
                      Discovery session. Please email ownyourmoneync@gmail.com
                      for additional information.
                    </p>
                    <p className="gift-certificate-note">
                      <em>
                        The MoneyMoon Package is an excellent gift for an
                        engagement or wedding. The Know Your Money Package is an
                        excellent choice for a graduation gift.
                      </em>
                    </p>
                  </div>
                  <p className="option-price">Available</p>
                </div>
              </div>

              <div className="consultation-button">
                <button className="primary-btn" onClick={toggleContactModal}>
                  Schedule a Consultation
                </button>
              </div>
              <div className="payment-notice">
                <p>All payments must be made in advance of services</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      {isContactModalOpen && <ContactUs onClose={toggleContactModal} />}
      <Footer />
    </>
  );
}
